const ArgumentType = require('../extension-support/argument-type');
const BlockType = require('../extension-support/block-type');
const Cast = require('../util/cast');

class Scratch3Device {
    constructor(runtime) { this.runtime = runtime; }
    getInfo() {
        return {
            id: 'deviceExt', name: '📱 デバイス', color1: '#607D8B', color2: '#546E7A',
            blocks: [
                { opcode: 'isMobile', blockType: BlockType.BOOLEAN, text: 'モバイル？' },
                { opcode: 'os', blockType: BlockType.REPORTER, text: 'OS' },
                { opcode: 'browser', blockType: BlockType.REPORTER, text: 'ブラウザ' },
                { opcode: 'pixelRatio', blockType: BlockType.REPORTER, text: 'ピクセル比' },
                { opcode: 'vibrate', blockType: BlockType.COMMAND, text: '[MS] ミリ秒振動', arguments: { MS: { type: ArgumentType.NUMBER, defaultValue: 200 } } }
            ]
        };
    }
    _ua() { return navigator.userAgent.toLowerCase(); }
    isMobile() { return /iphone|android.*mobile|windows.*phone/.test(this._ua()); }
    os() { var ua = this._ua(); if (ua.includes('win')) return 'Windows'; if (ua.includes('mac')) return 'macOS'; if (ua.includes('linux')) return 'Linux'; if (ua.includes('android')) return 'Android'; if (ua.includes('iphone')) return 'iOS'; return 'Unknown'; }
    browser() { var ua = this._ua(); if (ua.includes('chrome') && !ua.includes('edge')) return 'Chrome'; if (ua.includes('firefox')) return 'Firefox'; if (ua.includes('safari') && !ua.includes('chrome')) return 'Safari'; if (ua.includes('edge')) return 'Edge'; return 'Unknown'; }
    pixelRatio() { return window.devicePixelRatio || 1; }
    vibrate(args) { if (navigator.vibrate) navigator.vibrate(Cast.toNumber(args.MS)); }
}
module.exports = Scratch3Device;